module.exports = __webpack_public_path__ + "static/media/LpZBP8auyRAOtz6ewyw42rKbMKQFIoEnYwyC4eDe.05a4a305.webp";